import { render, staticRenderFns } from "./StampShop.vue?vue&type=template&id=e1447c36&scoped=true&"
import script from "./StampShop.vue?vue&type=script&lang=js&"
export * from "./StampShop.vue?vue&type=script&lang=js&"
import style0 from "./StampShop.vue?vue&type=style&index=0&id=e1447c36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1447c36",
  null
  
)

export default component.exports